import {apiSlice} from './apiSlice';

/**
 * Quản trị gói Subscription (admin) — features/Member/PlanManager. CRUD subscription_plans.
 * Tag 'Plan' để tự refetch danh sách sau khi thêm/sửa/xóa.
 */
export const planApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAdminPlans: builder.query({
			query: () => ({url: 'admin/plans', method: 'get'}),
			transformResponse: (body) => body?.data || [],
			providesTags: ['Plan'],
		}),
		createPlan: builder.mutation({
			query: (body) => ({url: 'admin/plans', method: 'post', data: body}),
			invalidatesTags: ['Plan'],
		}),
		updatePlan: builder.mutation({
			query: ({id, ...body}) => ({url: `admin/plans/${id}`, method: 'put', data: body}),
			invalidatesTags: ['Plan'],
		}),
		deletePlan: builder.mutation({
			query: (id) => ({url: `admin/plans/${id}`, method: 'delete'}),
			invalidatesTags: ['Plan'],
		}),
	}),
});

export const {
	useGetAdminPlansQuery,
	useCreatePlanMutation,
	useUpdatePlanMutation,
	useDeletePlanMutation,
} = planApiSlice;
